var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaliper(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1303_6813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.84942 0H15.7123C15.7123 0 16.6688 0.00760346 17.6091 0.430759C18.4486 0.808552 19.2663 1.48898 19.4203 2.89898H13.6409C13.4134 2.89976 13.2295 3.08374 13.2287 3.31117L13.2278 5.79476H9.91751V3.31117C9.91673 3.08374 9.73275 2.89981 9.50532 2.89898H5.77802C5.77802 2.89898 5.45221 2.89164 5.13711 2.73409C4.94361 2.63731 4.69735 2.31274 4.58594 2.0714H7.43402C7.66383 2.07228 7.8503 1.88576 7.84942 1.656V0Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77738 6.62311H19.4164C19.2865 7.99638 18.4473 8.71307 17.6085 9.0905C16.6681 9.51366 15.7117 9.51806 15.7117 9.51806H7.84877V7.86288C7.84794 7.63426 7.66194 7.44981 7.43338 7.45069H4.58203C4.70943 7.03628 4.94188 6.88204 5.13646 6.78475C5.45157 6.62719 5.77738 6.62311 5.77738 6.62311Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.50391 10.3464H13.6394V12.0016H12.4118C11.8599 12.0016 11.8599 12.83 12.4118 12.83H13.6394V14.4852H12.4118C11.8599 14.4852 11.8599 15.3128 12.4118 15.3128H13.6394V16.9671H12.4118C11.8599 16.9671 11.8599 17.7947 12.4118 17.7947H13.6394V18.6207C13.6394 19.2619 13.3556 19.5421 13.0405 19.6996C12.7254 19.8572 12.3996 19.8645 12.3996 19.8645H10.7436C10.7436 19.8645 10.417 19.8572 10.1019 19.6996C9.78684 19.5421 9.50391 19.2618 9.50391 18.6207V10.3464Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1562 20.6921H11.9838V23.5878C11.9838 23.8212 11.8051 24 11.5716 24C11.3382 24 11.1562 23.8212 11.1562 23.5878V20.6921Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1303_6813",
    x1: 19.4203,
    y1: 5.79476,
    x2: 10.3331,
    y2: -2.73896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E9E38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1303_6813",
    x1: 19.4164,
    y1: 9.51806,
    x2: 15.6443,
    y2: 2.42729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E9E38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1303_6813",
    x1: 13.6394,
    y1: 19.8645,
    x2: 8.9901,
    y2: 19.1235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E9E38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1303_6813",
    x1: 11.9838,
    y1: 24,
    x2: 11.0378,
    y2: 23.9132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E9E38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1303_6813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaliper);
export default __webpack_public_path__ + "static/media/caliper.3b933ec1ffa12a790910c28460aa8ad3.svg";
export { ForwardRef as ReactComponent };